import React from 'react';
import style from './visaMessage.module.scss';
import { FormattedMessage } from 'react-intl';

const VisaMessage: React.SFC<{}> = () => {
    return (
        <ul className={style.VisaMessage}>
            <li className={style.VisaListItem}>
                <FormattedMessage
                    id={'components.itineraryLegs.pleaseEnsurePassengerDetails'}
                    defaultMessage={
                        'Please ensure you provide your Account Manager with a full list of passenger names and passport details.'
                    }
                />
            </li>
            <li className={style.VisaListItem}>
                <FormattedMessage
                    id={'components.itineraryLegs.visaMessage'}
                    defaultMessage={
                        'All passengers must hold the necessary travel documents ' +
                        '(including passports, visa, health and other certificates) ' +
                        'for departure from the Country of origin, transit through any intermediate points and entry into the country of ' +
                        'destination of the flight.'
                    }
                />
            </li>
        </ul>
    );
};

export {VisaMessage};
